import React, { useContext } from "react";
import { QuestionSection, Radio } from "../../components/utility/quote";
import { navigate } from "gatsby-link";

import EnergyContext from "../../contexts/energyContext";
import Electricty from "../../svgs/energy/Electricity";
import Gas from "../../svgs/energy/Gas";
import Both from "../../svgs/energy/Both";

const Next = "/energy/Questions/2";
const Points = [
  {
    question: "What type of business energy are you looking for?",
    progress: "20%",
    options: [
      {
        answer: "Electricity",
        to: Next,
        icon: <Electricty />,
      },
      {
        answer: "Gas",
        to: Next,
        icon: <Gas />,
      },
      {
        answer: "Gas & Electricity",
        to: Next,
        icon: <Both />,
      },
    ],
  },
];

export default function Question1({ title }) {
  const { que1, setQue1 } = useContext(EnergyContext);

  return Points.map((item) => {
    return (
      <QuestionSection
        title={title}
        question={item.question}
        progress={item.progress}
      >
        {item.options.map((items) => {
          return (
            <Radio
              key={items.answer}
              icon={items.icon}
              value={items.answer}
              title={items.answer}
              isSelected={que1 === items.answer}
              onChange={(e) => {
                setQue1(e.target.value);
                navigate(items.to);
              }}
            />
          );
        })}
      </QuestionSection>
    );
  });
}
